<template>
  <v-container fluid class="down-top-padding">
    <base-breadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></base-breadcrumb>
    <base-card heading="Professores">
      <datatable-list
        :text="text"
        :headers="headers"
        :sortBy="sortBy"
        :items="items"
        :showSelect="showSelect"
        :tableUser="true"
      ></datatable-list>
    </base-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    page: {
      title: 'Professores'
    },
    breadcrumbs: [
      {
        text: 'Início',
        disabled: false,
        to: '/'
      },
      {
        text: 'Professores',
        disabled: false,
        to: '/teacher/list'
      }
    ],
    text: {
      searchLabel: 'Pesquisar Professores',
      emptyLabel: 'Nenhum professor encontrado',
      addLabel: 'Adicionar Professores',
      addUrl: '/school/add',
      importLabel: 'Importar Professores',
      importUrl: '/school/add'
    },
    headers: [
      {
        text: 'Nome',
        align: 'start',
        value: 'name'
      },
      { text: 'Escolas', value: 'schoolName' },
      { text: 'Nº Turmas', value: 'numberOfClass' }
    ],
    sortBy: 'name',
    showSelect: true,
    items: [
      {
        id: 1,
        schoolName: [
          'Escola Municipal Batel',
          'Escola Municipal Batel'
        ],
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        name: 'Lucinéia Percigili',
        email: 'embatel@sme.curitiba.pr.gov.br',
        numberOfClass: '345',
        url: '/user/profile'
      },
      {
        id: 2,
        schoolName: 'Escola Municipal Batel',
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        name: 'Josélia Percigili',
        email: 'embatel@sme.curitiba.pr.gov.br',
        numberOfClass: '345',
        url: '/user/profile'
      }
    ]
  })
}
</script>
